// Single source of truth for redirect path normalization, shared by the sync
// (compile) and edge (match) layers so "/old/" and "/old" always share one key.
// Strips a single trailing slash; never strips the root "/".
export function normalizePath(path: string): string {
  if (path.length > 1 && path.endsWith("/")) return path.slice(0, -1);
  return path;
}

// Reduces a redirect source to its pathname. Editors may paste a full URL
// ("https://stickergiant.com/old") or a path ("/old"); middleware only matches
// against our own host, so we keep just the pathname. A bare source ("old")
// gains a leading slash. Kept edge-safe (no path-to-regexp).
export function toSourcePath(value: string): string {
  try {
    return new URL(value).pathname;
  } catch {
    if (!value) return value;
    return value.startsWith("/") ? value : `/${value}`;
  }
}
